<script setup>
import { defineProps, ref, computed, getCurrentInstance } from "vue";

defineProps({
  item: {
    type: Object,
    required: true
  },
  onClick: {
    type: Function,
    required: true
  }
});

const { proxy } = getCurrentInstance();

const imageLoaded = ref(true); // 이미지 로드 상태를 관리하는 ref
const lobbyVisibility = computed(() => {
  return process.env.VUE_APP_LOBBY_VISIBILITY || proxy.$store.state.settings.lobby_visibility;
});

const getCardClass = (item) => {
  return {
    'grayscale': lobbyVisibility.value === 'grayscale' && item.maintenance,
    'hidden': lobbyVisibility.value === 'hidden' && item.maintenance
  }
}

const handleImageError = () => {
  imageLoaded.value = false;
};
</script>

<template>
  <div
    class="item" v-if="imageLoaded"
    :class="getCardClass(item)"
  >
    <div class="wptb-image-box2 wow fadeInLeft">
      <div class="wptb-item--inner">
        <div
          class="wptb-item--image"
          :class="getCardClass(item)"
        >
          <img 
            :src="item.providerImage" 
            alt="img" 
            @error="handleImageError"
          />
          <div
            v-if="item.providerImageText"
            class="absolute top-50 left-0 h-fit flex items-start justify-center w-full px-4 py-1"
            style="transform: translateY(-50%);"
          >
            <img :src="item.providerImageText" alt="img" />
          </div>
        </div>
        <div class="wptb-item--holder">
          <button
            class="wptb-item--wrap-content absolute bottom-5"
            :class="getCardClass(item)"
            @click="onClick(item)"
          >
            <span class="wptb-item--icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="13"
                viewBox="0 0 53 13"
                fill="none"
              >
                <g clip-path="url(#clip0_1_28160)">
                  <path
                    d="M24.0596 0H16.9192L3.78125 12.5875H10.9217L24.0596 0Z"
                    fill="#D70006"
                  />
                  <path
                    d="M37.8565 0H30.7161L17.5781 12.5875H24.7186L37.8565 0Z"
                    fill="#D70006"
                  />
                  <path
                    d="M51.6495 0H44.5029L31.3711 12.5875H38.5054L51.6495 0Z"
                    fill="#D70006"
                  />
                </g>
                <defs>
                  <clipPath>
                    <rect width="53" height="12.5875" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span class="wptb-item--button">
              <span class="btn-three">
                <span class="btn-wrap">
                  <span class="text-first" style="margin-bottom: 20px">
                    PLAY NOW
                  </span>
                  <span class="text-second">
                    <i class="bi bi-arrow-right"></i>
                  </span>
                </span>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-three .btn-wrap {
  font-weight: 800;
  color: white;
}

.btn-three .btn-wrap:hover {
  color: red;
}

.grayscale {
  pointer-events: none; /* 유지보수 중인 게임은 클릭 비활성화 */
}

.hidden {
  display: none !important;
}
</style> 